export default __webpack_public_path__ + "static/media/radar-chart.4ac37cce.svg";